import { render, staticRenderFns } from "./fieldOneToMany.vue?vue&type=template&id=98114dc0&"
import script from "./fieldOneToMany.vue?vue&type=script&lang=js&"
export * from "./fieldOneToMany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports